import * as Yup from 'yup';

export const vetEditValidation = Yup.object({
  bond: Yup.string().defined('Campo obrigatório'),
  // password: Yup.string(),
  // confirmPassword: Yup.string()
  //   .oneOf([Yup.ref('password'), null], 'Senha não coincidem')
  //   .required('Cofirmação de senha é obrigatória'),
});
